import { SidePaneTheme as baseTheme } from "@acin.reactjs/acin-ui/sidePane";

const SidePaneTheme = (): baseTheme => ({
  content: {
    root: {
      overflowY: "auto",
      marginInline: "20px",
    },
  },
  root: {
    zIndex: 1600,
  },
  overlay: {
    root: {
      zIndex: 1600,
    },
    fade: {
      root: {
        zIndex: 1600,
      },
    },
  },
});

export default SidePaneTheme;
